<div
  [ngClass]="{'widget': true, 'no-click': widget.type === 'None', 'disabled': widget.disabled}"
  (click)="selectWidget()"
>
  <div
    class="widget-bg"
    [ngStyle]="{
      'background-color': getBackgroundColor(),
      'background-image': background
    }"
  >
    <div class="{{ getIconPlacement() }}">
      <i
        class="{{ getIcon() }}"
        [ngStyle]="{ color: widget?.style?.iconColor }"
      ></i>
    </div>
    <div class="{{ getFontPlacement() }}">
      <div
        *ngIf="roadmapTitle"
        [ngStyle]="{ color: getTextColor(), fontSize: getLabelSize(), fontFamily: getFontStyle() }"
        class="widget-label roadmap-title"
      >
        {{ widget.label }}
      </div>
      <div
        *ngIf="!roadmapTitle"
        [ngStyle]="{ color: getTextColor(), fontSize: getLabelSize(), fontFamily: getFontStyle() }"
        class="{{ getTitleStyle() }}"
      >
        {{ widget.label }}
      </div>
      <div
        *ngIf="widget.description"
        [ngStyle]="{ color: getDescriptionColor() }"
        class="widget-label widget-description"
      >
        {{ widget.description }}
      </div>
    </div>
  </div>
</div>
